module.exports = __webpack_public_path__ + "assets/img/btn-detail-93f036d9.png";